import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onBeforeUnmount } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'mount-trigger',
  emits: ["mounted", "unmounted"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

onMounted(() => {
  emit('mounted');
});

onBeforeUnmount(() => {
  emit('unmounted');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span"))
}
}

})